/** Demo data for the AI agents section (?mock=1). */
import { AI_CATALOGUE_VERSION, AI_DEFAULT_LIMITS } from '@orgus/protocol';
import type { AiActivity, AiConnectInfo, AiState } from '@orgus/protocol';

export function mockAiState(now: number = Date.now()): AiState {
  const s = 1000;
  const m = 60 * s;
  const act = (i: number, at: number, actor: string, capability: string, tier: AiActivity['tier'], outcome: AiActivity['outcome'], message?: string, auditId?: string): AiActivity => ({
    id: `aia_demo${i}`,
    at: now - at,
    actor,
    actorKind: actor.startsWith('agent:') ? 'agent' : 'human',
    capability,
    tier,
    outcome,
    ms: 40 + i * 7,
    ...(message ? { message } : {}),
    ...(auditId ? { auditId } : {}),
  });
  return {
    version: AI_CATALOGUE_VERSION,
    limits: AI_DEFAULT_LIMITS,
    agents: [
      { id: 'agent:ops', name: 'ops', tokenId: 'tok_01JA8Q2M', role: 'operator', ceiling: 'operate', firstSeenAt: now - 6 * 24 * 60 * m, lastSeenAt: now - 40 * s, lastActionAt: now - 12 * m, readsToday: 214, actionsToday: 6, refusedToday: 1 },
      { id: 'agent:nightly-janitor', name: 'nightly-janitor', tokenId: 'tok_01JA9C7K', role: 'admin', ceiling: 'elevated', firstSeenAt: now - 3 * 24 * 60 * m, lastSeenAt: now - 7 * 60 * m, lastActionAt: now - 7 * 60 * m, readsToday: 18, actionsToday: 3, refusedToday: 0 },
      { id: 'agent:watcher', name: 'watcher', tokenId: 'tok_01JAB0RD', role: 'viewer', ceiling: 'read', firstSeenAt: now - 26 * 60 * m, lastSeenAt: now - 3 * m, lastActionAt: null, readsToday: 96, actionsToday: 0, refusedToday: 0 },
    ],
    recent: [
      act(1, 40 * s, 'agent:ops', 'needs_you.list', 'read', 'ok'),
      act(2, 2 * m, 'agent:ops', 'session.transcript', 'read', 'ok'),
      act(3, 3 * m, 'agent:watcher', 'state.summary', 'read', 'ok'),
      act(4, 12 * m, 'agent:ops', 'pipeline.pause', 'operate', 'ok', 'Paused the landing queue', 'au_demo41'),
      act(5, 14 * m, 'agent:ops', 'job.run', 'critical', 'refused', 'Run a command was refused. Run a command is a critical capability, and only a person may use those.'),
      act(6, 31 * m, 'agent:ops', 'session.stop', 'operate', 'ok', 'Stopped session 7f3a on build-01', 'au_demo40'),
      act(7, 46 * m, 'owner', 'approvals.list', 'read', 'ok'),
      act(8, 7 * 60 * m, 'agent:nightly-janitor', 'worktree.remove', 'elevated', 'ok', 'Removed worktree feat/old-menu on devbox', 'au_demo33'),
      act(9, 7 * 60 * m + 20 * s, 'agent:nightly-janitor', 'worktree.remove', 'elevated', 'error', 'The worktree has 3 changed files.'),
    ],
  };
}

export function mockConnectInfo(): AiConnectInfo {
  const hubUrl = 'http://127.0.0.1:4600';
  const cli = 'C:/Users/you/orgus/tools/orgus-cli/bin/orgus.mjs';
  return {
    hubUrl,
    command: 'node',
    args: [cli, 'mcp'],
    mcpJson: JSON.stringify(
      { mcpServers: { orgus: { type: 'stdio', command: 'node', args: [cli, 'mcp'], env: { ORGUS_URL: hubUrl, ORGUS_TOKEN: '${ORGUS_TOKEN}' } } } },
      null,
      2,
    ),
    claudeCommand: `claude mcp add orgus --env ORGUS_URL=${hubUrl} --env ORGUS_TOKEN="<agent token>" -- node ${cli} mcp`,
    tokenPlaceholder: '<agent token>',
  };
}
